<template>
  <div class="team-setting">
    <div class="search-user">
      <el-input v-model="searchText" class="search-text" placeholder="输入用户名或手机号" @keyup.enter="searchUser" />
      <el-button class="search-btn" type="primary" @click="searchUser()">搜索</el-button>
    </div>
    <div class="context-user">
      <el-table ref="teamTable" :data="tableData" row-key="userId" style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" :row-style="getRowStyle"
        default-expand-all>
        <el-table-column prop="userId" label="用户编号" />
        <el-table-column prop="nickName" label="真实姓名">
          <template #default="scope">
            <el-input v-if="editingRowIndex === scope.$index" v-model="scope.row.nickName" />
            <span v-else @click="editRealName(scope.$index, scope.row.nickName, scope.row.userLevel)">
              {{ scope.row.nickName || '暂无姓名' }}
            </span>

          </template>
        </el-table-column>
        <el-table-column prop="userName" label="用户名" />
        <el-table-column prop="phone" label="用户电话" />
        <el-table-column prop="userType" label="用户级别">
          <template #default="scope">
            <el-select v-model="scope.row.userLevel" clearable placeholder=""
              v-if="scope.row.userLevel == (userAuthority + 1)" @change="updateCascaderLevel(scope.$index)">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
                :disabled="isOptionDisabled(item.value)" />
            </el-select>

            <span v-else>
              {{ getLevelLabel(scope.row.userLevel) }}
            </span>

          </template>
        </el-table-column>
        <el-table-column prop="atlasCodeId" label="用户区域">
          <template #default="scope">
            <el-cascader ref="cascaderRef" v-model="scope.row.selectedArea" :show-all-levels="false"
              v-if="scope.row.userLevel == (userAuthority + 1)"
              :options="getUserAreaFilteredCodeList(scope.row.userLevel)" placeholder="" :props="cascaderProps"
              clearable />

            <span v-else>
              {{ getAreaLabel(scope.row.selectedArea) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="70">
          <template #default="scope">
            <el-button link type="primary" size="small" @click="modifyAuthority(scope.row)"
              v-if="scope.row.userLevel == (userAuthority + 1)">
              保存
            </el-button>
            <el-button link type="primary" size="small" @click="clearAuthority(scope.row, scope.$index)"
              v-if="scope.row.userLevel == (userAuthority + 1)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog v-model="dialogTableVisible" :show-close="false" width="800" @click.stop>
      <template #header="{ close, titleId, titleClass }">
        <div class="user-info-header">
          <h4 :id="titleId" :class="titleClass">用户</h4>
          <div class="user-info-close" @click.stop="close">×</div>
        </div>
      </template>
      <div class="user-info-context">
        <el-table :data="searchData" :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="userId" label="用户编号" />
          <el-table-column prop="nickName" label="真实姓名" />
          <el-table-column prop="userName" label="用户名" />
          <el-table-column prop="phonenumber" label="用户电话" />
          <el-table-column prop="userType" label="用户级别">
            <template #default="scope">
              <!-- 显示中文级别描述 -->
              {{ getLevelLabel(scope.row.userLevel) }}
            </template>
          </el-table-column>
          <el-table-column prop="msg" label="备注" width="120" />

          <el-table-column fixed="right" label="操作" min-width="70">
            <template #default="scope">
              <el-button link type="primary" v-show="scope.row.type == '0'" size="small"
                @click="addTableData(scope.$index)">
                添加
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- <el-dialog v-model="dialogTableVisible" title="用户" width="800">
      
    </el-dialog> -->
  </div>
</template>

<script>
import { getUserList, getUserAuthorityList, addUserAuthority, updateUserAuthority, delUserAuthority, updateUserInfo } from '@/api/Common';
import { useMapStore } from '@/stores/mapStore';
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: "TeamSetting",
  components: {},
  data() {
    return {
      dialogTableVisible: false,
      userInfo: null,
      mapStore: null,
      searchText: "",
      userList: [],
      searchData: [],
      searchDataKey: [],
      editingRowIndex: -1, // 初始化编辑行索引为 -1，表示没有行在编辑
      oldRealName: '',
      tableData: [
      ],
      options: [
        { value: 0, label: '超级管理员' },
        { value: 1, label: '省级' },
        { value: 2, label: '市级' },
        { value: 3, label: '区级' }
      ],
      levelColors: {
        0: '#ffffff',  // 超级管理员
        1: '#ffffff',  // 省级
        2: '#ffffee',  // 市级
        3: '#ffffdd'   // 区级
      },
      authorityList: [],
      codeList: [],
      codeListKey: 0,
      // 配置 cascader 的 props
      cascaderProps: {
        label: 'atlasName', // 指定显示的字段为 atlasName
        value: 'id', // 通常指定 value 字段，可根据实际情况修改
        children: 'children', // 指定子节点字段
        multiple: true
      },
      maxLevel: 2, // 限制选择的最大级数，可按需修改
      userAuthority: 4,
      userArea: [],
    };
  },
  mounted() {

    this.mapStore = useMapStore();
    let that = this;

    this.mapStore.loadCodeList(function () {


      that.userInfo = that.mapStore.getUserInfo();

      that.getUserAuthorityList({ userId: that.userInfo.userId });


      that.codeList = that.mapStore.codeList;

    });



  },
  // 添加 watch 选项监听 mapStore.codeList 的变化
  // watch: {
  //   'mapStore.codeList': {
  //     handler(newValue) {
  //       if (newValue != null) {
  //         this.codeList = newValue;
  //         console.log(newValue);
  //         // 当 codeList 变化时，更新 codeListKey 触发重新渲染
  //         this.codeListKey++;
  //         this.setSelectedAreas();

  //       }
  //     },
  //     deep: false// 深度监听对象内部变化

  //   }
  // },
  methods: {

    getRowStyle({ row }) {
      return {
        backgroundColor: this.levelColors[row.userLevel] || '#ffffff'
      }
    },
    editRealName(index, realName, level) {
      console.log(level);
      if (level == (this.userAuthority + 1)) {
        this.editingRowIndex = index;
        this.oldRealName = realName; // 存储旧的真实姓名
      }
    },
    addTableData(index) {
      // 获取对应索引的行数据
      const rowData = this.searchData[index];
      // 检查 tableData 中是否存在相同 userId 的对象
      const existingUser = this.tableData.some(item => item.userId === rowData.userId);
      if (!existingUser) {
        // 若不存在，则添加到 tableData 中
        this.tableData.push(rowData);
      }
      this.dialogTableVisible = false;
    },
    searchUser() {

      let phoneParams = {
        phonenumber: this.searchText,
        userId: this.userInfo.userId
      }
      this.searchData = [];
      this.searchDataKey = [];
      //
      let that = this;

      getUserList(phoneParams).then(res => {
        if (res.code == 200) {
          let searchList = [];
          if (res.datas) {
            searchList = [res.datas];
          } else if (res.rows) {
            searchList = res.rows;
          }

          // 遍历 searchList 数组
          searchList.forEach(tableItem => {
            let userItem = {
              userId: tableItem.userId,
              phone: tableItem.phonenumber,
              userName: tableItem.userName,
              avatar: tableItem.avatar,
              nickName: tableItem.nickName,
              type: tableItem.type,
            }
            // 查找 searchAuthorityList 中 userId 相等的对象
            const matchingAuthoritys = that.authorityList.filter(authItem => authItem.userId === userItem.userId);

            if (matchingAuthoritys && matchingAuthoritys.length > 0) {
              if (!userItem.selectedArea) {
                userItem.selectedArea = [];
              }
              for (const matchingAuthority of matchingAuthoritys) {
                const path = that.findPath(that.codeList, matchingAuthority.atlasCodeId);

                // 若找到匹配项，赋值 userType 和 atlasCodeId 属性
                if (userItem.userLevel == undefined || userItem.userLevel > matchingAuthority.userType) {
                  userItem.userLevel = matchingAuthority.userType;
                }
                if (path) {
                  const isPathIncluded = userItem.selectedArea.some(arr =>
                    arr.length === path.length && arr.every((value, index) => value === path[index])
                  );
                  if (!isPathIncluded) {
                    userItem.selectedArea.push(path);
                  }
                }
              }
              if (that.userAuthority < userItem.userLevel) {
                if (that.searchDataKey.indexOf(userItem.userId) == -1) {
                  that.searchDataKey.push(userItem.userId);
                  that.searchData.push(userItem);
                }
              }
            }
            else {
              if (that.searchDataKey.indexOf(userItem.userId) == -1) {
                that.searchDataKey.push(userItem.userId);
                that.searchData.push(userItem);
              }
            }

          });
        }
        this.dialogTableVisible = true;
      });

    },
    delUserAuthority(params) {
      delUserAuthority(params).then(res => {
        if (res.code == 200) {

        }
      })
    },
    clearAuthority(item, index) {
      let that = this;

      ElMessageBox.confirm(
        '确认删除用户"' + item.userName + '"的权限?',
        '删除权限',
        {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          const requests = [];
          // 查找 authorityList 中是否存在 userId 相等的对象
          // let existingAuthorities = this.authorityList.filter(authority => authority.userId === item.userId);
          requests.push(that.delUserAuthority([{ userId: item.userId }]));
          // existingAuthorities.forEach((existingAuthority, index) => {
          //   requests.push(that.delUserAuthority({ id: existingAuthority.id }));
          // });

          // 使用 Promise.all 等待所有请求完成
          Promise.all(requests).then(() => {
            that.tableData.splice(index, 1);
            that.authorityList = that.authorityList.filter(authItem => authItem.userId !== item.userId);
            ElMessage.success("修改成功！");
          }).catch(() => {
            ElMessage.error("修改失败，请重试！");
          });

        })
        .catch(() => {

        })

    },
    modifyAuthority(item) {
      // 查找 authorityList 中是否存在 userId 相等的对象
      let existingAuthorities = this.authorityList.filter(authority => authority.userId === item.userId);
      let selectedAreas = item.selectedArea;

      const requests = [];
      if (item.userLevel - this.userAuthority != 1) {
        alert("不能跨级别操作！");
        return;
      }

      existingAuthorities.forEach((existingAuthority, index) => {

        if (index < selectedAreas.length) {
          const path = selectedAreas[index];
          let currentPath = path[path.length - 1];

          const node = this.findItemById(this.codeList, currentPath);
          const nodeName = node ? node.atlasName : '';
          existingAuthority.atlasCodeId = currentPath;
          existingAuthority.city = nodeName;

          existingAuthority.userType = item.userLevel;
          existingAuthority.pid = this.userInfo.userId;
          // 执行更新操作
          requests.push(this.updateUserAuthority(existingAuthority));
        } else {
          // 执行更新操作
          requests.push(this.delUserAuthority([existingAuthority]));

        }
      });


      // 如果 selectedAreas 数量多于 existingAuthorities，需要添加新的授权信息
      if (selectedAreas.length > existingAuthorities.length) {
        for (let i = existingAuthorities.length; i < selectedAreas.length; i++) {
          const path = selectedAreas[i];
          let addItem = Object.assign({}, item);
          let currentPath = path[path.length - 1];

          const node = this.findItemById(this.codeList, currentPath);
          const nodeName = node ? node.atlasName : '';
          addItem.city = nodeName;
          addItem.atlasCodeId = currentPath;
          addItem.userType = item.userLevel;
          addItem.pid = this.userInfo.userId;
          // 执行添加操作
          requests.push(this.addUserAuthority(addItem));
          this.authorityList.push(addItem);
        }
      }
      // 使用 Promise.all 等待所有请求完成
      Promise.all(requests).then(() => {
        ElMessage.success("修改成功！");
      }).catch(() => {
        ElMessage.error("修改失败，请重试！");
      });

    },

    addUserAuthority(params) {
      let that = this;
      addUserAuthority(params).then(res => {
        if (res.code == 200) {

        }
      })
    },
    updateUserAuthority(params) {
      let that = this;
      updateUserAuthority(params).then(res => {
        if (res.code == 200) {

        }
      })
    },
    getCurrentUserAuthority() {

      const currentUsers = this.authorityList.filter(authItem => authItem.userId === this.userInfo.userId);//that.userInfo.userId

      if (currentUsers) {
        for (const currentUser of currentUsers) {
          if (this.userAuthority > currentUser.userType) {
            this.userAuthority = currentUser.userType;
          }
          const path = this.findPath(this.codeList, currentUser.atlasCodeId);
          if (path) {
            const isPathIncluded = this.userArea.some(arr =>
              arr.length === path.length && arr.every((value, index) => value === path[index])
            );
            if (!isPathIncluded) {
              this.userArea.push(path);
            }
          }

        }
        //that.userAuthority = currentUser.userType;
      }

    },

    getUserAuthorityList(params) {
      let that = this;
      getUserAuthorityList(params).then(res => {
        if (res.code == 200) {

          that.authorityList = res.rows;

          that.getCurrentUserAuthority();


          let userMap = {};
          that.authorityList.forEach((item) => {
            if (userMap.hasOwnProperty(item.userId)) {
              userMap[item.userId].push(item);
            }
            else {
              userMap[item.userId] = [item];
            }
          });
          let userListMap = {};
          Object.keys(userMap).forEach((key) => {
            let value = userMap[key];
            let tableItem = value[0];
            tableItem.selectedArea = [];
            value.forEach((item) => {
              // 若找到匹配项，赋值 userType 和 atlasCodeId 属性
              if (tableItem.userLevel == undefined || tableItem.userLevel > item.userType) {
                tableItem.userLevel = item.userType;
              }
              let path = that.findPath(that.codeList, item.atlasCodeId);
              if (path) {

                if (path && path.length >= that.userAuthority) {
                  path = path.slice(that.userAuthority);
                }
                const isPathIncluded = tableItem.selectedArea.some(arr =>
                  arr.length === path.length && arr.every((value, index) => value === path[index])
                );
                if (!isPathIncluded) {
                  tableItem.selectedArea.push(path);
                }
              }
            })
            if (that.userAuthority < tableItem.userLevel) {
              userListMap[tableItem.userId] = {
                ...tableItem,
                children: []
              };
              //that.tableData.push(tableItem);

            }
          })
          let tempData = []; // 临时存储构建中的树形数据
          // 2. 构建树形结构
          Object.values(userListMap).forEach(node => {
            if (node.pid && userListMap[node.pid]) {
              if (!userListMap[node.pid].children) {
                userListMap[node.pid].children = [];
              }
              userListMap[node.pid].children.push(node);
            } else {
              tempData.push(node);
            }
          });
          Object.values(userListMap).forEach(node => {
            if (node.userLevel - that.userAuthority === 1) {
              that.tableData.push(node);
            }
          });
          // console.log(that.tableData);
          // // 3. 过滤并处理层级关系
          // that.tableData = tempData.filter(item => {
          //   if (that.userAuthority < item.userType) {
          //     // 处理selectedArea等属性
          //     item.selectedArea = [];
          //     that.authorityList.filter(a => a.userId === item.userId).forEach(authItem => {
          //       let path = that.findPath(that.codeList, authItem.atlasCodeId);
          //       if (path && path.length >= that.userAuthority) {
          //         path = path.slice(that.userAuthority);
          //         const isPathIncluded = item.selectedArea.some(arr =>
          //           arr.length === path.length && arr.every((value, index) => value === path[index])
          //         );
          //         if (!isPathIncluded) {
          //           item.selectedArea.push(path);
          //         }
          //       }
          //     });
          //     return true;
          //   }
          //   return false;
          // });



        }
      });
    },

    getUserList(params) {
      let that = this;


      getUserList(params).then(res => {

        if (res.code == 200) {

          that.userList = res.rows;

        }
      });
    },

    getAreaLabel(selectedArea) {
      if (!selectedArea || selectedArea.length === 0) return '未设置区域';

      // 获取所有区域的名称
      const areaNames = selectedArea.map(areaPath => {
        const lastId = areaPath[areaPath.length - 1];
        const node = this.findItemById(this.codeList, lastId);
        return node ? node.atlasName : '未知区域';
      });

      return areaNames.join(', ');
    },



    setSelectedAreas() {

      this.tableData.forEach(tableItem => {
        const matchingAuthority = this.authorityList.find(authItem => authItem.userId === tableItem.userId);
        if (matchingAuthority) {
          tableItem.userLevel = matchingAuthority.userType;

          const path = this.findPath(this.codeList, matchingAuthority.atlasCodeId);
          tableItem.selectedArea = path;
        }
      });
    },

    // 判断选项是否禁用的方法
    isOptionDisabled(value) {

      // 示例：禁止选择值为 '3' 的选项，可根据实际需求修改
      //return value <= this.userAuthority ;

      return (value - this.userAuthority) != 1;
    },
    // 根据用户级别过滤 codeList
    getFilteredCodeList(userLevel) {
      const maxLevel = userLevel + 1;
      return this.filterCodeList(this.codeList, 1, maxLevel);
    },
    // 递归过滤 codeList
    filterCodeList(list, currentLevel, maxLevel) {
      return list.map(item => {
        const newItem = { ...item };
        if (currentLevel < maxLevel && newItem.children) {
          newItem.children = this.filterCodeList(newItem.children, currentLevel + 1, maxLevel);
        } else {
          delete newItem.children;
        }
        return newItem;
      });
    },
    // 递归查找路径
    findPath(list, targetId, path = []) {
      if (!Array.isArray(list)) {
        return null;
      }
      for (const item of list) {
        const newPath = [...path, item.id];
        if (item.id === targetId) {
          return newPath;
        }
        if (item.children) {
          const result = this.findPath(item.children, targetId, newPath);
          if (result) {
            return result;
          }
        }
      }
      return null;
    },
    // 根据 userArea 过滤 codeList
    getUserAreaFilteredCodeList(userLevel) {

      const maxLevel = userLevel + 1 - this.userAuthority;
      const filteredList = [];
      for (const areaPath of this.userArea) {
        const lastId = areaPath[areaPath.length - 1];
        const foundItem = this.findItemById(this.codeList, lastId);
        if (foundItem) {
          filteredList.push(...this.filterCodeList([foundItem], 1, maxLevel));
        }
      }
      return filteredList;
    },
    // 根据 id 查找节点
    findItemById(list, targetId) {
      for (const item of list) {
        if (item.id === targetId) {
          return item;
        }
        if (item.children) {
          const result = this.findItemById(item.children, targetId);
          if (result) {
            return result;
          }
        }
      }
      return null;
    },
    // 根据用户级别值获取对应的中文描述
    getLevelLabel(levelValue) {
      const option = this.options.find(item => item.value === levelValue);
      return option ? option.label : levelValue;
    },
    // 用户级别改变时更新 cascader 可选级别
    updateCascaderLevel(index) {
      // 这里可以添加额外逻辑，比如刷新表格等
    }
  },
};
</script>

<style scoped>
.el-dialog {
  padding: 0px !important;
}

.user-info-close {
  color: #fff;
  font-size: 26px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
}

.user-info-header {
  position: relative;
  height: 46px;
  padding:
    12px;
  background-color: #1b2d3e;
  color: #fff;
  border-radius:
    5px 5px 0 0;

}

.user-info-header h4 {
  color: #fff;
}

.user-info-context {
  padding: 10px;
}




.team-setting {
  overflow: auto;
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #f0f2f5;
}

.search-user {
  height: 80px;
  border-radius: 10px;
  background-color: white;
  margin: 10px;

}

.search-text {
  margin-left: 20px;
  width: calc(100% - 100px);
  height: 40px;
  margin-top: 20px;
  border: 1px solid #eee;

}

.search-btn {
  height: 40px;
  margin-top: 20px;
}

.context-user {
  height: calc(100% - 90px);
  background-color: white;
  border-radius: 10px;
  margin: 10px;
}
</style>
